/**
 *
 *
 */
export const SHEET_ACTION_CLOSE_BUTTON = ["close-button", "closedWithX"] as const;

/**
 *
 *
 */
export const SHEET_ACTION_BACK_BUTTON = ["back-button", "closedWithBackNavigation"] as const;

/**
 *
 *
 */
export const SHEET_ACTION_BACK_DROP = ["back-drop", "closedWithCurtainClick"] as const;

/**
 *
 *
 *
 *
 */
export const SHEET_ACTION_DRAG_DOWN = ["drag-down", "closedWithDrag"] as const;

/**
 *
 *
 *
 */
export const SHEET_ACTION_ESCAPE_KEY = ["escape-key", "closedWithEscape"] as const;

/**
 *
 *
 *
 *
 */
export const SHEET_ACTION_PROGRAMMATICALLY = [
  "programmatically",
  "closedProgrammatically",
] as const;

/**
 *
 *
 *
 */
export const SHEET_ACTION_USER_AGENT = ["user-agent", "closedWithUserAgent"] as const;

/**
 *
 *
 *
 */
export const SHEET_ACTION_PAGE_ENTRY_URL = ["page-entry-url", "page-entry-url"] as const;

/**
 *
 *
 */
export type OcSheetV1ActivationAction =
  | (typeof SHEET_ACTION_CLOSE_BUTTON)[0]
  | (typeof SHEET_ACTION_BACK_BUTTON)[0]
  | (typeof SHEET_ACTION_BACK_DROP)[0]
  | (typeof SHEET_ACTION_DRAG_DOWN)[0]
  | (typeof SHEET_ACTION_ESCAPE_KEY)[0]
  | (typeof SHEET_ACTION_PROGRAMMATICALLY)[0]
  | (typeof SHEET_ACTION_USER_AGENT)[0]
  | (typeof SHEET_ACTION_PAGE_ENTRY_URL)[0];

/**
 *
 */
export type OcSheetV1CloseTypes =
  | (typeof SHEET_ACTION_CLOSE_BUTTON)[1]
  | (typeof SHEET_ACTION_BACK_BUTTON)[1]
  | (typeof SHEET_ACTION_BACK_DROP)[1]
  | (typeof SHEET_ACTION_DRAG_DOWN)[1]
  | (typeof SHEET_ACTION_ESCAPE_KEY)[1]
  | (typeof SHEET_ACTION_PROGRAMMATICALLY)[1]
  | (typeof SHEET_ACTION_USER_AGENT)[1]
  | (typeof SHEET_ACTION_PAGE_ENTRY_URL)[1];
